import React, { Component, createRef } from "react";
import * as s from "./DateRangeDropdown.module.scss";
import { Icons } from "src/libs/assets";
import { P, DateRange } from "src/views/shared/components";
import { observer } from "mobx-react";
import AnimateHeight from "react-animate-height";
import { tx } from "src/libs/i18n";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  dropdownTitle: string;
  toggleYear: any;
  selectedOptions: { value: number }[];
}

interface State {
  dropdownOpen: boolean;
  inputContainerSelected: boolean;
  lastTwoYears: number[];
  lowerRangeValue: number;
}

@observer
export class DateRangeDropdown extends Component<Props, State> {
  private lowerDateRangeRef = createRef<any>();
  private upperDateRangeRef = createRef<any>();

  state = {
    dropdownOpen: false,
    inputContainerSelected: false,
    lastTwoYears: [],
    lowerRangeValue: 0
  };

  toggleOpen = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  componentDidMount = () => {
    const { lastTwoYears } = this.state;
    var currentDate = new Date();
    const arrClone = lastTwoYears.slice();
    for (let i = 0; i < 2; i++) {
      arrClone.push(currentDate.getFullYear() - i),
        this.setState({
          lastTwoYears: arrClone
        });
    }
  };

  renderOption = (value, key) => {
    const { selectedOptions } = this.props;
    let selected = selectedOptions.some(obj => obj.value === value);
    let optionItemClasses = [s.optionItem];

    if (selected) optionItemClasses.push(s.selected);

    return (
      <P
        className={optionItemClasses.join(" ")}
        key={key}
        onClick={() => this.onOptionClick(value)}
      >
        {tx("misc.sinceValue", { value })}
      </P>
    );
  };

  onDateRangeClick = () => {
    const { lowerDateRangeRef, upperDateRangeRef } = this;

    if (
      lowerDateRangeRef.current.value === "" ||
      upperDateRangeRef.current.value === ""
    ) {
      this.setState({ inputContainerSelected: true });
    } else {
      this.setState({ inputContainerSelected: false });
    }
  };

  onOptionClick = (year: number = null) => {
    const { props } = this;
    const { toggleYear } = props;

    this.setState({ inputContainerSelected: false });
    toggleYear(year);
  };

  onDateRangeInputChange = e => {
    const { toggleYear } = this.props;
    const { lowerDateRangeRef, upperDateRangeRef } = this;
    if (
      lowerDateRangeRef.current.value !== "" ||
      upperDateRangeRef.current.value !== ""
    ) {
      this.setState({ inputContainerSelected: true });
    } else {
      this.setState({ inputContainerSelected: false });
    }

    if (!e.target.min) {
      this.setState({ lowerRangeValue: e.target.value });
    }

    if (e.target.value.length > 4) {
      e.target.value = e.target.value.slice(0, 4);
    }

    if (e.target.value > e.target.max) {
      e.target.value = e.target.max;
    }

    if (e.target.min && e.target.value.length >= 4 && e.target.value < e.target.min) {
      e.target.value = parseInt(e.target.min) + 1;
    }

    const lowerDateRangeValue = lowerDateRangeRef && lowerDateRangeRef.current.value;
    const lowerDateRangeValueLength = lowerDateRangeValue.length;

    const upperDateRangeValue = upperDateRangeRef && upperDateRangeRef.current.value;
    const upperDateRangeValueLength = upperDateRangeValue.length;

    if (lowerDateRangeValueLength === 4 && upperDateRangeValueLength === 4) {
      toggleYear(parseInt(lowerDateRangeValue), parseInt(upperDateRangeValue));
    }
  };

  render() {
    const { lowerDateRangeRef } = this;
    const { className, dropdownTitle, selectedOptions, toggleYear } = this.props;
    const { dropdownOpen, inputContainerSelected, lastTwoYears } = this.state;

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const lastYear = currentDate.getFullYear() - 1;

    const resetOptionClasses = [s.optionItem];
    const filterDropdownClasses = [s.filterDropdown];
    const rangeOptionsContainerLabelClasses = [s.rangeOptionsContainerLabel];
    let icon = Icons.chevronDown_large;

    if (selectedOptions.length === 0) resetOptionClasses.push(s.selected);

    if (className) {
      filterDropdownClasses.push(className);
    }

    if (dropdownOpen) {
      filterDropdownClasses.push(s.open);
      icon = Icons.chevronUp_large;
    }

    if (inputContainerSelected) {
      rangeOptionsContainerLabelClasses.push(s.selected);
    }

    return (
      <div className={filterDropdownClasses.join(" ")}>
        <div className={s.dropdownHeader} onClick={this.toggleOpen}>
          <h6 className={s.dropdownTitle}>{dropdownTitle}</h6>
          <img src={icon} className={s.chevronDown} alt="Arrow down" />
        </div>
        <AnimateHeight height={dropdownOpen ? "auto" : 0}>
          <div className={s.optionsContainer}>
            <P
              className={resetOptionClasses.join(" ")}
              onClick={() => this.onOptionClick()}
            >
              {tx("misc.anytime")}
            </P>
            {/* {lastTwoYears && lastTwoYears.map(this.renderOption)} */}
          </div>
          <div className={s.rangeOptionsContainer}>
            <P
              className={rangeOptionsContainerLabelClasses.join(" ")}
              onClick={() =>
                lowerDateRangeRef.current && lowerDateRangeRef.current.focus()
              }
            >
              {tx("dateRangeDropdown.customDateRange")}
            </P>
            <DateRange
              lowerRangeLabel={tx("dateRangeDropdown.lowerRangeLabel")}
              lowerRangePlaceholder="YYYY"
              lowerRangeMax={lastYear}
              upperRangeLabel={tx("dateRangeDropdown.upperRangeLabel")}
              upperRangePlaceholder="YYYY"
              upperRangeMax={currentYear}
              onInputChange={toggleYear}
            />
          </div>
        </AnimateHeight>
      </div>
    );
  }
}
